<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center pb-2">
      <img src="assets/img/svg/T.svg" alt="Tracey logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 d-flex">
        <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
      </div>
    </div>
    <div class="body-wrapper">
      @if (raceStartDateType === RaceStartDateType.START) {
        <div class="pb-4">
          <input type="checkbox" class="form-check-input border-2 me-2" id="startOnlyRdy" [(ngModel)]="startOnlyRdy"/>
          <label class="form-check-label" for="startOnlyRdy">{{ t("measurements.start.only.rdy") }}</label>
        </div>
      }
      <table class="w-100">
        <thead class="admin-modal-table-underline">
        <tr>
          <th class="py-6">{{ t('measurements.race.name') }}</th>
          <th class="py-6">{{ t('measurements.race.start.by.gender') }}</th>
          <th class="py-6">{{ t('competitor.table.startBlock') }}</th>
          <th class="py-6">{{ t('measurements.race.started') }}</th>
          <th class="py-6"></th>
        </tr>
        </thead>
        <tbody>
          @for (race of listOfRaces; track race; let outerIdx = $index) {
            @for (raceStartItem of race.raceStartItems; track raceStartItem; let idx = $index) {
              <tr class="admin-modal-table-underline">
                @if (idx === 0) {
                  <td [rowSpan]="race.raceStartItems?.length" class="py-6 limited-width">
                    <app-language-output [hrLabel]="race.name"
                                         [enLabel]="race.nameEng"
                                         [itLabel]="race.nameIta"
                                         [siLabel]="race.nameSlo"
                                         [srLabel]="race.nameSr"
                                         [bsLabel]="race.nameBs"
                                         [languages]="languages"/>
                  </td>
                }
                <td class="py-6">@if (raceStartItem.type === RaceStartType.MAN) {
                  {{ t('measurements.race.start.by.gender.man') }}
                } @else if (raceStartItem.type ===
                RaceStartType.WOMAN) {
                  {{ t('measurements.race.start.by.gender.woman') }}
                } @else {
                  {{ '-' }}
                }
                </td>
                <td class="py-6">{{ raceStartItem.blockNumber ? raceStartItem.blockNumber : '-' }}</td>
                <td class="py-6">{{
                    raceStartItem.started ? (raceStartItem.started | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'
                  }}
                </td>
                <td class="py-6">
                  @if (RaceStartDateType.START === raceStartDateType) {
                    @if(Race.isChronometerRace(race!.startEvery)) {
                      &nbsp;
                    } @else {
                      <input type="checkbox" [disabled]="!!raceStartItem.started" class="form-check-input border-2"
                             [(ngModel)]="raceStartItem.selected"/>
                    }
                  } @else if (RaceStartDateType.EDIT === raceStartDateType) {
                    @if(Race.isChronometerRace(race!.startEvery)) {
                      &nbsp;
                    } @else {
                      <input type="radio" class="form-check-input" [value]="outerIdx + '-' + idx"
                             [disabled]="!raceStartItem.started || Race.isChronometerRace(race!.startEvery)"
                             [(ngModel)]="selectedRadioButton"
                             (click)="onSelect(raceStartItem)"/>
                    }
                  } @else {
                    <input type="checkbox" [disabled]="!raceStartItem.started"
                           class="form-check-input border-2"
                           [(ngModel)]="raceStartItem.selected"/>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
      @if (raceStartDateType === RaceStartDateType.EDIT) {
        <form [formGroup]="inputForm">
          <div class="pt-3 d-flex align-items-center flex-column">
            <div class="row g-2 w-100 justify-content-center pb-2">
              <div class="col-5">
                <app-date-time-input formControlName="time" [displayTime]="true" [displaySeconds]="true"
                                     [displayMilliseconds]="true" [label]="t('measurements.time')"
                                     [openDropdownUpwards]="true"/>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>

  <div class="d-flex justify-content-center align-items-center pb-40-48">
    <div class="d-flex">
      <div class="pe-3">
        <app-rounded-button [label]="dismissButtonTitle ?? t('app.common.cancel')"
                            [btnClass]="'btn-grey text-uppercase'" (onClick)="onDismissClick()"/>
      </div>
      <app-rounded-button [label]="confirmButtonTitle ?? t('app.common.confirm')" (onClick)="onConfirmClick()"
                          [btnClass]="'btn-primary-red text-uppercase'"
                          [isDisabled]="!isAnyRaceSelected() && raceStartDateType !== RaceStartDateType.EDIT"></app-rounded-button>
    </div>
  </div>
</ng-container>
